import {
    Notification
} from 'element-ui';
import {
    i18n
} from "@/plugins/vuei8n";

const state = {
    loginForm: {
        email: null,
        password: null
    }
};

const mutations = {
    setState: (state, {
        key,
        value
    }) => {
        state[key] = value;
    }
};

const actions = {
    async login({
        state,
        commit
    }, form) {
        const response = await this.$api.auth.login(form);

        if (response.status == 200) {
            this.$api.auth.$axios.setToken(true, response.data);
            this.router.push({
                path: '/client/orders'
            });
            commit('setState', {
                key: 'loginForm',
                value: {
                    email: null,
                    password: null
                }
            });
        }

        return response;
    },
    async register({
        commit
    }, form) {
        const response = await this.$api.auth.register(form);

        if (response.status == 201) {
            this.$api.auth.$axios.setToken(true, response.data);
            this.router.push({
                path: '/client/orders'
            });
        }

        return response;
    },
    logout() {
        this.$api.auth.$axios.clearCookies();
        this.router.push({
            path: '/auth/login'
        });
    },
    async check({
        dispatch
    }, form) {
        const {
            data
        } = await this.$api.auth.check(form);

        if (!isNew(data)) {
            await dispatch('login', form);
            return;
        }

        localStorage.setItem('userPhone', form.phone);
        this.router.push({
            name: 'Signup'
        });
    },
    async verifyCode({
        state,
        commit,
        dispatch
    }, form) {
        try {

            await this.$api.auth.verifyCode(form);
            dispatch('check', form);

        } catch (err) {
            if (err.response.status === 409) {
                Notification({
                    title: i18n.t("notifications.codeNotVerided"),
                    message: i18n.t("notifications.codeNotVeridedText"),
                    duration: 1300
                });
            }
        }
    },
    async signup({
        state,
        commit
    }, form) {},
    async send({
        state,
        commit
    }, form) {
        return await this.$api.auth.send(form);
    },


};

const getters = {
    loginForm: state => state.loginForm
};

function isNew(v) {
    return v.exists == false;
}

export default {
    namespaced: true,

    state,
    mutations,
    actions,
    getters
};